import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { Base as OhCase } from "../../ohCase";
import { Base as Immunisations } from "../../../immunisations";
import { Base as OccupationalIllness } from "../../../occupationalIllness";
import { Base as GPSpecialistInfo } from "../../../generalPractitionerSpecialistInfo";

import { ClinicalHistory } from "../../../clinicalHistory/components/ClinicalHistory";
import { TaskActionSubRoutes } from "../../../task/taskActions/TaskActionSubRoutes";
import { EmployeeRecordRecalls } from "../../../healthSurveillance/recalls/components/EmployeeRecordRecalls";
import { ApplicationState } from "../../../applicationState";
import { loadEmployeeRecordDetail } from "../actions";

import { All } from "./All";
import { Detail } from "./Detail";
import { EditModal } from "./EditModal";
import { BaseItemExtensions } from "./BaseItemExtensions";
import { BaseRootExtensions } from "./BaseRootExtensions";
import { CreateModal } from "./CreateModal";

import { EmployeeRecordAuditLog } from "./EmployeeRecordAuditLog";

import { Fragment, Location } from "redux-little-router";

export const Base: React.FC = () => {
    const employeeRecordIdIsUndefined = React.useCallback((l: Location) => l.params?.employeeRecordId === undefined, []);

    const dispatch = useDispatch();
    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);
    const employeeRecordId = useSelector((state: ApplicationState) => state.router.params!.employeeRecordId);

    React.useEffect(() => {
        if (customerId && employeeRecordId) {
            dispatch(loadEmployeeRecordDetail({ customerId, employeeRecordId }));
        }
    }, [customerId, dispatch, employeeRecordId]);

    return (
        <div>
            <Fragment forRoute="/" withConditions={employeeRecordIdIsUndefined}>
                <div>
                    <All />
                    <CreateModal />
                    <BaseItemExtensions />
                </div>
            </Fragment>
            <Fragment forRoute="/:employeeRecordId/ohCases">
                <OhCase />
            </Fragment>
            <Fragment forRoute="/:employeeRecordId/immunisations">
                <Immunisations />
            </Fragment>
            <Fragment forRoute="/:employeeRecordId/occupationalIllness">
                <OccupationalIllness />
            </Fragment>
            <Fragment forRoute="/:employeeRecordId/gpSpecialistInfo">
                <GPSpecialistInfo />
            </Fragment>
            <Fragment forRoute="/:employeeRecordId/clinicalHistory">
                <>
                    <Fragment forRoute="/:ohCaseId">
                        <TaskActionSubRoutes />
                    </Fragment>
                    <Fragment forRoute="/">
                        <ClinicalHistory />
                    </Fragment>
                </>
            </Fragment>
            <Fragment forRoute="/:employeeRecordId/healthSurveillanceRecalls">
                <EmployeeRecordRecalls />
            </Fragment>
            <Fragment forRoute="/:employeeRecordId/auditLog">
                <EmployeeRecordAuditLog />
            </Fragment>
            <Fragment forRoute="/:employeeRecordId">
                <div>
                    <Detail />
                    <EditModal />
                    <BaseRootExtensions />
                </div>
            </Fragment>
        </div>
    );
};
